import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/main/content.sss';

export default class MainContent extends Component {
	getTitle() {}

	getDescription() {}

	renderHeader() {
		return (
			<header class={joinClasses(s.header, this.s?.header)}>
				<h2>{this.getTitle()}</h2>
				<p class={s.description}>{this.getDescription()}</p>
				<div class={s.buttons}>{this.renderButtons()}</div>
				{this.renderExtraHeaderContent()}
			</header>
		);
	}

	renderExtraHeaderContent() {}

	renderButtons() {}

	renderContent() {}

	render() {
		return (
			<div class={joinClasses(s.wrapper, this.s?.wrapper)}>
				{this.renderHeader()}
				{this.renderContent()}
			</div>
		);
	}
}